import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faStar,
  faDove,
  faThList,
  faEnvelope,
  faPaperPlane,
  faTh,
  faDownload,
} from "@fortawesome/free-solid-svg-icons"
import {
  fab,
  faTwitter,
  faWhatsapp,
  faDiscord,
  faSlack,
  faGithub,
} from "@fortawesome/free-brands-svg-icons"

library.add(
  fab,
  faEnvelope,
  faPaperPlane,
  faStar,
  faTwitter,
  faDownload,
  faWhatsapp,
  faDove,
  faThList,
  faTh,
  faDiscord,
  faSlack,
  faGithub
)
